import React, { useEffect, useState, useRef, memo } from 'react';

const COLORS = {
  green: {
    border: 'border-green-400',
    text: 'text-green-400',
    hover: 'hover:bg-green-400/5',
    shadow: 'hover:shadow-green-400/30'
  },
  blue: {
    border: 'border-blue-400',
    text: 'text-blue-400',
    hover: 'hover:bg-blue-400/5',
    shadow: 'hover:shadow-blue-400/30'
  },
  red: {
    border: 'border-red-400',
    text: 'text-red-400',
    hover: 'hover:bg-red-400/5',
    shadow: 'hover:shadow-red-400/30'
  },
  yellow: {
    border: 'border-yellow-400',
    text: 'text-yellow-400',
    hover: 'hover:bg-yellow-400/5',
    shadow: 'hover:shadow-yellow-400/30'
  },
    grey: {
    border: 'border-grey-400',
    text: 'text-grey-400',
    hover: 'hover:bg-grey-400/5',
    shadow: 'hover:shadow-grey-400/30'
  },
};

const TypingText = memo(({ text, isHovered, text_after, delay = 0 }) => {
  const [displayText, setDisplayText] = useState('');
  const typingTimeout = useRef(null);
  const typingInterval = useRef(null);

  useEffect(() => {
    if (isHovered) {
      setDisplayText('');
      let i = 0;

      typingTimeout.current = setTimeout(() => {
        typingInterval.current = setInterval(() => {
          i++;
          setDisplayText(text_after.slice(0, i));
          if (i >= text.length) {
            clearInterval(typingInterval.current);
          }
        }, 50);
      }, delay);
    } else {
      clearTimeout(typingTimeout.current);
      clearInterval(typingInterval.current);
      setDisplayText(text);
    }

    return () => {
      clearTimeout(typingTimeout.current);
      clearInterval(typingInterval.current);
    };
  }, [isHovered, text, delay]);

  return <span>{displayText}</span>;
});

const TypingTextButton = memo(({
  text = "INIT_GAME.exe",
  onClick,
  text_after,
  disabled,
  delay = 0,
  variant = "green", // 'green' | 'blue' | 'red' | 'yellow'
  className = "",
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const colors = COLORS[variant] || COLORS.green;

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`
        group relative px-5 py-3 bg-black border ${colors.border} ${colors.text}
        font-mono font-bold uppercase tracking-widest transition-all duration-300
        ${colors.hover} hover:shadow-lg ${colors.shadow} ${className} rounded-xl
      `}
      disabled={disabled}
    >
      <div className="relative flex items-center justify-center">
        <span className="opacity-50">[</span>

        <span className="mx-2 inline-block relative w-[12ch] whitespace-nowrap overflow-hidden">
          <span className="invisible absolute">{text}</span>
          <TypingText
            text={text}
            isHovered={isHovered}
            delay={delay}
            text_after={text_after}
          />
        </span>

        <span className="opacity-50">]</span>
      </div>
    </button>
  );
});

export default TypingTextButton;
